export const BULK_UPLOAD_RETURN_TO = {
  atlas: "atlas",
  library: "library",
} as const;

export type BulkUploadReturnTo = (typeof BULK_UPLOAD_RETURN_TO)[keyof typeof BULK_UPLOAD_RETURN_TO];

export const DEFAULT_BULK_UPLOAD_RETURN_TO: BulkUploadReturnTo = BULK_UPLOAD_RETURN_TO.atlas;

export function normalizeReturnTo(raw: unknown): BulkUploadReturnTo {
  return raw === BULK_UPLOAD_RETURN_TO.library ? BULK_UPLOAD_RETURN_TO.library : DEFAULT_BULK_UPLOAD_RETURN_TO;
}

/** Route location for vue-router after bulk upload completes. */
export function returnToRouteLocation(customerId: string, value: BulkUploadReturnTo): {
  name: "CommunityPhotos" | "CalendarUploadContent";
  params: { pageId: string } | { customerId: string };
} {
  if (value === BULK_UPLOAD_RETURN_TO.library) {
    return { name: "CommunityPhotos", params: { pageId: customerId } };
  }
  return { name: "CalendarUploadContent", params: { customerId } };
}

export function returnToLabel(value: BulkUploadReturnTo): string {
  return value === BULK_UPLOAD_RETURN_TO.library ? "Photos" : "Content Calendar";
}
